import { useEffect, useRef } from 'react'

export default function GameTooltip({ emoji, title, message, buttonText, arrowSide, onDismiss }) {
  const btnRef = useRef(null)

  useEffect(() => {
    btnRef.current?.focus()
  }, [])

  const arrowClass = {
    left:   'justify-start pl-8',
    right:  'justify-end pr-8',
    center: 'justify-center',
  }[arrowSide] ?? 'justify-center'

  return (
    <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-end px-5 pb-[72px]">
      <div className="w-full max-w-xs">
        <div className="bg-gray-900/80 backdrop-blur-sm border border-white/10 rounded-2xl p-5 shadow-2xl">
          <div className="text-5xl text-center mb-3 leading-none select-none">{emoji}</div>
          <h3 className="text-white font-semibold text-lg text-center mb-2">{title}</h3>
          <p className="text-white/75 text-sm text-center leading-relaxed mb-4 whitespace-pre-line">{message}</p>
          <button
            ref={btnRef}
            onClick={onDismiss}
            className="w-full bg-white text-indigo-900 rounded-2xl py-3 font-semibold text-sm active:scale-95 transition-transform"
          >
            {buttonText}
          </button>
        </div>
        {/* Flèche pointant vers la zone HUD concernée */}
        <div className={`flex mt-1.5 ${arrowClass}`}>
          <span className="text-white/40 text-xl leading-none select-none">▼</span>
        </div>
      </div>
    </div>
  )
}
